import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { CallState } from "redmond";
import { IStoreState } from "../../../../reducers/types";
import {
  setContactInfo,
  fetchApplicableTravelWalletItems,
  resetPaymentCardSelectedAccounts,
  setPriceQuote,
  setUserSelectedPassengerIds,
  scheduleVacationRentalPriceQuote,
  scheduleVacationRentalsBook,
  addMainGuest,
} from "../../actions/actions";
import { MobileVacationRentalsBookWorkflow } from "./component";
import {
  getSelectedPaymentMethodId,
  getSession,
  getUserSelectedTravelerId,
  hasNoUserPassengersSelector,
  getConfirmationPhoneNumber,
  getConfirmationEmail,
  getPriceDifferenceAcknowledged,
  getPriceQuoteErrors,
  getConfirmationDetailsError,
  getOffers,
  getRewardsPaymentAccountReferenceId,
  getCreditToApply,
  getVacationRentalsPriceQuote,
  getVacationRentalsIsTravelWalletPaymentOnly,
  getVacationRentalsIsBookingValid,
  getVacationRentalsPollPriceQuoteCallState,
  getVacationRentalsSchedulePriceQuoteCallState,
  getVacationRentalConfirmationDetails,
  getUserSelectedTraveler,
  getApplicableCredit,
} from "../../reducer";
import { getPremierCollectionShopSelectedAvailability } from "../../../shop/reducer/selectors";
import { fetchTravelWalletCreditHistory } from "../../../travel-wallet/actions/actions";
import { getRewardsAccountWithLargestEarnForBanner } from "../../../rewards/reducer";
import { getVacationRentalShopSelectedListing } from "../../../vacation-rental-shop/reducer";
import { getIsTravelApp } from "../../../availability/reducer";
import { setIsTravelApp } from "../../../availability/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  priceQuote: getVacationRentalsPriceQuote(state),
  priceQuoteInProgress:
    getVacationRentalsSchedulePriceQuoteCallState(state) ===
      CallState.InProcess ||
    getVacationRentalsPollPriceQuoteCallState(state) === CallState.InProcess,
  priceQuoteErrors: getPriceQuoteErrors(state),
  currentSession: getSession(state),

  paymentMethodId: getSelectedPaymentMethodId(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  selectedLodging: getPremierCollectionShopSelectedAvailability(state),
  isBookingValid: getVacationRentalsIsBookingValid(state),
  hasNoUserPassengers: hasNoUserPassengersSelector(state),
  confirmationEmail: getConfirmationEmail(state),
  confirmationPhoneNumber: getConfirmationPhoneNumber(state),
  priceDifferenceAcknowledged: getPriceDifferenceAcknowledged(state),
  confirmationDetailsErrors: getConfirmationDetailsError(state),
  offers: getOffers(state),
  rewardsPaymentAccountReferenceId: getRewardsPaymentAccountReferenceId(state),
  isTravelWalletPaymentOnly: getVacationRentalsIsTravelWalletPaymentOnly(state),
  creditToApply: getCreditToApply(state),
  credit: getApplicableCredit(state),
  largestEarnAccount: getRewardsAccountWithLargestEarnForBanner(state),
  selectedHome: getVacationRentalShopSelectedListing(state),
  vrReservation: getVacationRentalConfirmationDetails(state),
  userSelectedTraveler: getUserSelectedTraveler(state),
  isTravelApp: getIsTravelApp(state),
});

const mapDispatchToProps = {
  scheduleVacationRentalPriceQuote,
  setContactInfo,
  scheduleVacationRentalsBook,
  fetchApplicableTravelWalletItems,
  resetPaymentCardSelectedAccounts,
  setPriceQuote,
  fetchTravelWalletCreditHistory,
  setUserSelectedPassengerIds,
  addMainGuest,
  setIsTravelApp,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileVacationRentalsBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileVacationRentalsBookWorkflow = withRouter(
  connector(MobileVacationRentalsBookWorkflow)
);
